// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container[data-v-53138e92]{\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 84px);\n}\n", ""]);
// Exports
module.exports = exports;
